import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '../../context/AuthContext';
import ParallaxBackground from '../../components/common/ParallaxBackground';
import ParallaxTiltCard from '../../components/common/ParallaxTiltCard';
import '../../styles/login.css';

export default function LoginPage() {
  const { login } = useAuth();
  const navigate = useNavigate();
  const [adminAccount, setAdminAccount] = useState('');
  const [adminPassword, setAdminPassword] = useState('');
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError('');
    setLoading(true);
    try {
      // 계정은 트림해 보낸다(생성 저장값과 일치). 비밀번호는 그대로 둔다.
      await login(adminAccount.trim(), adminPassword);
      navigate('/dashboard');
    } catch (err) {
      setError(err.response?.data?.message || err.message || '로그인에 실패했습니다.');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="login-screen">
      <ParallaxBackground />
      <ParallaxTiltCard className="login-card" maxTilt={4}>
        <div className="login-brand">
          <img src="/onetak-icon.svg" alt="onetak" className="login-brand-icon" />
          <div className="mark">one<span>tak</span></div>
          <div className="sub">관리자 사이트</div>
        </div>

        {error && <div className="login-error">{error}</div>}

        <form onSubmit={handleSubmit}>
          <div className="field">
            <label htmlFor="adminAccount">아이디</label>
            <input
              id="adminAccount"
              className="input"
              type="text"
              value={adminAccount}
              onChange={(e) => setAdminAccount(e.target.value)}
              autoComplete="username"
              required
            />
          </div>
          <div className="field">
            <label htmlFor="adminPassword">비밀번호</label>
            <input
              id="adminPassword"
              className="input"
              type="password"
              value={adminPassword}
              onChange={(e) => setAdminPassword(e.target.value)}
              autoComplete="current-password"
              required
            />
          </div>
          <button type="submit" className="btn btn-primary login-submit" disabled={loading}>
            {loading ? '로그인 중...' : '로그인'}
          </button>
        </form>

        <div className="login-footer">© onetak. All rights reserved.</div>
      </ParallaxTiltCard>
    </div>
  );
}
